export const checkClick = (
  e: Event,
  className: string,
  action: () => void,
): void => {
  const target = e.target as HTMLElement;

  if (
    target &&
    !(
      target.className.includes(className) ||
      target.parentElement?.className.includes(className)
    )
  )
    action();
};
